export const messages = fetchMessages();

function fetchMessages() {
  const modules = require.context('./', false, /.*\.json$/i);
  const msgs = {};
  modules.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1)  {
      Object.assign(msgs, modules(key));
    }
  })
  return msgs;
}